import { render, staticRenderFns } from "./OrgTreeNode.vue?vue&type=template&id=a58c1902"
import script from "./OrgTreeNode.vue?vue&type=script&lang=js"
export * from "./OrgTreeNode.vue?vue&type=script&lang=js"
import style0 from "./OrgTreeNode.vue?vue&type=style&index=0&id=a58c1902&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports